import React from 'react'
import './style.css'
const Space = ({ children }) => {
    return (
        <div className="space">
            {children}
        </div>
    )
}

export default Space